import { getIsGretaAIChatUserRole } from '../GretaAIChatMessage'

export function getGretaAIChatLastUserTurnIndex(turns) {
  return turns.findLastIndex(turn => getIsGretaAIChatUserRole(turn.role))
}

export function getGretaAIChatLastAssistantTurnIndex(turns) {
  return turns.findLastIndex(turn => !getIsGretaAIChatUserRole(turn.role))
}
